// extracted by mini-css-extract-plugin
module.exports = {"word":"word--NP4Do"};